import { connect } from 'react-redux';

import {
  FEATURE_CLIP_POST,
  JWT_SCOPE_MESSAGE_CLIP,
} from '../RemoteConfigKeys.js';

import withRouter from '../component/WithRouter.jsx';

import FlixDetailReaction from '../component/FlixDetailReaction.jsx';

import login from '../action/login.js';
import sendChatStart from '../action/sendChatStart.js';
import submitMessageRating from '../action/submitMessageRating.js';
import setGiftPanel from '../action/setGiftPanel.js';
import sendFollowUser from '../action/sendFollowUser.js';
import copyTextWithToastr from '../action/copyTextWithToastr.js';

import getMeData from '../selector/getMeData.js';
import getMessageData from '../selector/getMessageData.js';
import getMessageUnlockPrice from '../selector/getMessageUnlockPrice.js';
import getUserData from '../selector/getUserData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';

import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';

const mapStateToProps = (state, { messageId, location }) => {
  const unlockPrice = getMessageUnlockPrice(state, messageId);
  const senderId = getMessageData(state, messageId, 'senderId');
  const isFollowing = getUserData(state, senderId, 'isFollowing');
  const likeCount = getMessageData(state, messageId, 'likes');
  const isOnFreezoneDetail = getIsMatchedPathname({
    pathname: location?.pathname,
    dataKey: 'isOnFreezoneDetail',
  });
  return {
    meId: getMeData(state, 'id'),
    messageId,
    isFollowing,
    isOnFreezoneDetail,
    isClipEnabled: getRemoteConfigData(state, FEATURE_CLIP_POST) === 1,
    isClipPermissionMatched: getIsPermissionMatched(
      state,
      JWT_SCOPE_MESSAGE_CLIP
    ),
    senderId,
    senderUsername: getUserData(state, senderId, 'username'),
    ratedAs: getMessageData(state, messageId, 'ratedAs'),
    likeCount,
    unlockPrice,
  };
};

const mapDispatchToProps = (dispatch, { messageId }) => {
  return {
    login: () => dispatch(login()),
    sendChatStart: ({ userId }) => dispatch(sendChatStart({ userId })),
    submitMessageRating: ({ rating }) =>
      dispatch(submitMessageRating({ id: messageId, rating })),
    setGiftPanel: ({ isOpen }) => dispatch(setGiftPanel({ isOpen })),
    sendFollowUser: data => dispatch(sendFollowUser(data)),
    copyTextWithToastr: data => dispatch(copyTextWithToastr(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FlixDetailReaction)
);
